import { render, staticRenderFns } from "./AddCaseGroup.vue?vue&type=template&id=d3ad13a2&"
import script from "./AddCaseGroup.vue?vue&type=script&lang=js&"
export * from "./AddCaseGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports